import { map } from 'lodash'
import { SearchCallbackData } from '../apis/googlePlace.api'
import { SearchPickerOption } from '../components/SearchPicker'

export default {
  searchOptions (addresses: SearchCallbackData): SearchPickerOption[] {
    return map(addresses, address => {
      const { address: value, placeId } = address
      return { value, id: placeId }
    })
  }
}
